import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="flex items-center justify-center mb-8">
          <div className="w-12 h-12 rounded-xl bg-emerald-600 flex items-center justify-center mr-3">
            <i className="ri-stack-line text-white text-xl" />
          </div>
          <h1 className="text-xl font-semibold text-slate-900">Tradivo</h1>
        </div>
        <h2 className="text-3xl font-bold text-slate-900 mb-2">Page not found</h2>
        <p className="text-sm text-slate-500 mb-2">
          The page <code className="text-xs bg-slate-100 px-2 py-0.5 rounded font-mono text-slate-700">{location.pathname}</code> does not exist.
        </p>
        <p className="text-sm text-slate-500 mb-6">
          Check the URL or navigate back to a known section of the app.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to="/dashboard"
            className="px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium rounded-lg whitespace-nowrap"
          >
            Go to Dashboard
          </Link>
          <button
            onClick={() => window.history.back()}
            className="px-5 py-2.5 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 text-sm font-medium rounded-lg whitespace-nowrap"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}